// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__Pkky9","top":"style_top__vrM91","image":"style_image__zqYtK","text":"style_text__4vZSI","bottom":"style_bottom__mwT7y"};